import Vue from "vue";

export default {
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    setTmcRefreshingDevices: async ({commit}, refreshingDevices) => {
        commit('setTmcRefreshingDevices', refreshingDevices)
    },
    setTmcVideoPathRefreshingDevices: async ({commit}, refreshingDevices) => {
        commit('setTmcVideoPathRefreshingDevices', refreshingDevices)
    },
    setTmcLiveRefreshingDevices: async ({commit}, refreshingDevices) => {
        commit('setTmcLiveRefreshingDevices', refreshingDevices)
    },
    setTmcSelectedProcessingProject: async ({commit, dispatch}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/data-processing-report',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get processing project response: ', response)
                    if (response.status === 200) {
                        commit('setTmcSelectedProcessingProject', response.data)
                        await dispatch('getNearMissValidation', selectedProject)
                        await dispatch('refreshTmcLiveTasks', selectedProject)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setTmcSelectedProcessingProject', null)
            commit('setTmcSelectedVideoCalibration', null)
            commit('setTmcSelectedProcessingDevice', null)
        }
    },
    checkTmcVideoPathTasks: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'post',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/check-video-path-tasks',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Check video path tasks: ', response)
                    if (response.status === 200) {
                        commit('replaceTmcVideoPathTasks', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setTmcSelectedProcessingProject', null)
            commit('setTmcSelectedVideoCalibration', null)
            commit('setTmcSelectedProcessingDevice', null)
        }
    },
    refreshTmcLiveTasks: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/data-processing-live-report',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Refresh live tasks: ', response)
                    if (response.status === 200) {
                        commit('replaceTmcLiveTasks', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setTmcSelectedProcessingProject', null)
            commit('setTmcSelectedVideoCalibration', null)
            commit('setTmcSelectedProcessingDevice', null)
        }
    },
    getNearMissValidation: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'post',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/check-near-miss',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Get initial validation response: ', response)
                    if (response.status === 200) {
                        commit('mergeTmcInitialValidationData', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setTmcSelectedProcessingProject', null)
            commit('setTmcSelectedVideoCalibration', null)
            commit('setTmcSelectedProcessingDevice', null)
        }
    },
    runTmcInitialValidation: async ({commit, dispatch}, data) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/auto-validation',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {dataDeviceId: data.dataDeviceId},
        };

        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get run initial validation response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    commit('setRefreshForDataDevice', {id: data.dataDeviceId, refresh: true})
                    setTimeout(()=>{
                        dispatch('getNearMissValidation', data.selectedProject)
                    }, 3000)

                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    runTmcFullValidation: async ({commit, dispatch}, data) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/full-processing',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {dataDeviceId: data.dataDeviceId},
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get run full processing response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    commit('setTmcRefreshForDataDevice', {id: data.dataDeviceId, refresh: true})
                    //await new Promise(resolve => setTimeout(resolve, 3000));
                    setTimeout(()=>{
                        dispatch('getNearMissValidation', data.selectedProject)
                    }, 10000)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    runTmcPedestrianProcessing: async ({commit, dispatch}, data) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/ped-processing',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {dataDeviceId: data.dataDeviceId},
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get run pedestrian processing response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    commit('setTmcRefreshForDataDevice', {id: data.dataDeviceId, refresh: true})
                    //await new Promise(resolve => setTimeout(resolve, 3000));
                    setTimeout(()=>{
                        dispatch('getNearMissValidation', data.selectedProject)
                    }, 3000)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    setTmcSelectedProcessingDevice: async ({commit}, processingDevice) => {
        if (processingDevice) {
            commit('setTmcSelectedProcessingDevice', processingDevice)
        } else {
            commit('setTmcSelectedProcessingDevice', null)
        }
    },
    setTmcSelectedVideoCalibrations: async ({commit}, selectedCalibration) => {
        if (selectedCalibration) {
            commit('setTmcSelectedVideoCalibration', selectedCalibration)
        } else {
            commit('setTmcSelectedVideoCalibration', null)
        }
    },
    selectTmcCalibration: async ({commit}, calibration) => {
        if (calibration) {
            commit('selectTmcCalibration', calibration)
        } else {
            commit('selectTmcCalibration', null)
        }
    },
    saveTmcCalibration: async ({commit}, calibrationPayload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/video-calibration',
            headers: {
                'Content-Type': 'application/json'
            },
            data: calibrationPayload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get save video calibration response: ', response)
                if (response.status === 200) {
                    commit('replaceTmcVideoCalibrations', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    editTmcCalibration: async ({commit}, calibrationPayload) => {
        let config = {
            method: 'put',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/video-calibration',
            headers: {
                'Content-Type': 'application/json'
            },
            data: calibrationPayload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Update video calibration response: ', response)
                if (response.status === 200) {
                    commit('replaceTmcVideoCalibrations', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    createTmcTasks: async ({commit}, taskPayload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/bulk-tasks',
            headers: {
                'Content-Type': 'application/json'
            },
            data: taskPayload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Create Tasks response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    if (response.data && response.data.dataDeviceId) {
                        if(taskPayload.modelType === 'ai'){
                            commit('updateTmcDeviceTasks', response.data)
                        }else if(taskPayload.modelType === 'data_processing'){
                            commit('updateTmcVehicleProcessingTasks', response.data)
                        }
                    }
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    savePipeline: async ({commit}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/pipeline',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Save pipeline response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    if (response.data && response.data._id) {
                        commit('updatePipelineOnDataDevice', response.data)
                    }
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    pushTmcTasksToSqs: async ({commit, dispatch}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/tasks/push-v2',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload.data,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Push Tasks response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    if (response.data && response.data.dataDeviceId) {
                        commit('setTmcRefreshForDataDeviceStepOne', {id: payload.data.dataDeviceId, refresh: true})
                        setTimeout(()=>{
                            dispatch('checkTmcVideoPathTasks', payload.selectedProject)
                        }, 10000)
                    }
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    triggerBackProcessing: async ({commit, dispatch}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/trigger-lambda-by-name',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Trigger back processing response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Trigger back processing success: ', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    setDpLegendSelection: async ({commit}, selection) => {
        commit('setDpLegendSelection', selection)
    },
    getVideoUrl: async ({commit}, videoMetaDataId) => {
        let config = {
            method: 'get',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/video-presigned-url',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {videoMetaDataId: videoMetaDataId},
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Change video response: ', response)
                /*                if (response.status === 200) {
                                    commit('changeSelectedCalibrationVideo', response.data)
                                }*/
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    getAcceleratedVideoUrl: async ({commit}, videoMetaDataId) => {
        let config = {
            method: 'get',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/video-presigned-url',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {videoMetaDataId: videoMetaDataId, isAccelerated: true},
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Change video response: ', response)
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    resetTmcProcessingStep: async ({commit, dispatch}, data) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/reset-step',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Reset Processing Step Response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    if(data.stepName === 'video-path-tracking'){
                        commit('replaceTmcVideoPathData', response.data)
                    }else{
                        commit('replaceTmcValidationData', response.data)
                    }

                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    uploadTmcValidationData: async ({commit, dispatch}, data) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/upload-validation-data',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Upload validation data response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    commit('setTmcValidationData', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    updateProcessingPeriods: async ({commit, dispatch}, data) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/update-processing-periods',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Update Processing periods response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    return true
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
}

